import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { getDefaultRouteForRole } from '../../config/roles';

const AuthCallback: React.FC = () => {
  const [status, setStatus] = useState('Processing authentication...');
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();
  const { currentUser } = useAuth();

  useEffect(() => {
    // Check if we have a user (auth was successful)
    if (currentUser) {
      setStatus('Authentication successful! Redirecting...');
      const target = getDefaultRouteForRole(currentUser.role || 'finance');
      setTimeout(() => {
        navigate(target, { replace: true });
      }, 1500);
    } else {
      // If no user, there might be an error or the auth is still processing
      setTimeout(() => {
        if (!currentUser) {
          setError('Authentication failed. Please try again.');
          setTimeout(() => {
            navigate('/', { replace: true });
          }, 2000);
        }
      }, 3000);
    }
  }, [currentUser, navigate]);

  const isDarkMode = true; // Always dark for auth pages

  return (
    <div className={`min-h-screen flex items-center justify-center ${isDarkMode ? 'bg-slate-900' : 'bg-gray-50'}`}>
      <div className={`max-w-md w-full space-y-8 p-8 ${isDarkMode ? 'bg-slate-800' : 'bg-white'} rounded-xl shadow-lg text-center`}>
        <div className={`w-16 h-16 mx-auto ${isDarkMode ? 'bg-blue-600' : 'bg-blue-500'} rounded-full flex items-center justify-center mb-4`}>
          <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>

        <h2 className={`text-2xl font-bold ${isDarkMode ? 'text-white' : 'text-gray-900'} mb-2`}>
          Authentication
        </h2>

        {error ? (
          <div className="text-red-600 mb-4">{error}</div>
        ) : (
          <div className={`text-lg ${isDarkMode ? 'text-slate-300' : 'text-gray-600'} mb-4`}>
            {status}
          </div>
        )}

        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500 mx-auto"></div>
      </div>
    </div>
  );
};

export default AuthCallback;
